'use client';

import Image from 'next/image';
import { useIntl } from 'react-intl';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import { subscriptionBadgeSizeToPx } from '../SubscriptionBadge/Logo/logoBadgeSizeToPx';
import { SubscriptionBadgeBadgeProps } from '../SubscriptionBadge/Logo/types';
import plusFullDarkTextSrc from './plus-full-dark-text.svg';
import plusFullLightTextSrc from './plus-full-light-text.svg';
import plusIconCircleSrc from './plus-icon-circle.svg';
import plusIconSrc from './plus-icon.svg';

const getSvgSrc = ({ variant, textColor }: SubscriptionBadgeBadgeProps) => {
  switch (variant) {
    case 'icon':
      return plusIconSrc;
    case 'icon-circle':
      return plusIconCircleSrc;
    case 'full':
      if (textColor === 'light') {
        return plusFullLightTextSrc;
      }
      return plusFullDarkTextSrc;
    default:
      return plusFullDarkTextSrc;
  }
};

const PlusLogoBadge = ({ className, size = 'md', variant, textColor }: SubscriptionBadgeBadgeProps) => {
  const intl = useIntl();
  return (
    <Image
      {...setDenaliAttribute('SubscriptionBadge')}
      className={className}
      src={getSvgSrc({ variant, textColor })}
      height={subscriptionBadgeSizeToPx[size]}
      alt={intl.formatMessage({ defaultMessage: '{tier} badge image' }, { tier: 'Plus' })}
    />
  );
};
export default PlusLogoBadge;
